import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'approve-button',
  styleUrls: ['./approveButton.component.scss'],
  templateUrl: './approveButton.component.html',
})
export class ApproveButtonComponent implements AgRendererComponent {
  refresh(params: any): boolean {
    return undefined;
  }
  private params: any;
  public disabled: boolean = false;

  agInit(params: any): void {
    this.params = params;
    if (this.params.data.academyStatus) {
      this.disabled = this.params.data.academyStatus.appStatus === 'open';
    } else {
      this.disabled = this.params.data.active;
    }
  }

  public invokeEdit() {
    this.params.context.componentParent.onActionApproveClick(this.params.data);
  }
}
